<section class="section-logo">
  <div class="padding-section-medium">
    <div class="padding-global">
      <div class="container-small">
        <div class="margin-bottom margin-large">
          <div class="text-align-center">
            <div class="max-width-large align-center">
              <h2 class="text-size-medium is-brand" i18n="@@wf.logoStrip.title">Robust Infrastructure supported by Leading Ecosystems</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="logo-component">
    <div class="logo-list">
      <div class="logo-wrapper"><img [src]="wfImage('integraciones_02.png')" loading="lazy" width="194" alt="" class="logo is-wordpress"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('google-cloud-logo.svg')" loading="lazy" width="170" alt="" class="logo is-google"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('mongodb_slateblue.svg')" loading="lazy" width="170" alt="" class="logo is-mongo"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('twillio-1.png')" loading="lazy" width="125" alt="" class="logo is-twillio"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('whatsapp-partner.png')" loading="lazy" width="165" alt="" class="logo is-whatsapp"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('prestashop-mono-1.png')" loading="lazy" width="168" alt="" class="logo is-prestashop"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('shopify_monotone_black.svg')" loading="lazy" width="169" alt="" class="logo is-shopify"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('integraciones_04.png')" loading="lazy" width="167" alt="" class="logo is-tiendanube"/></div>
    </div>
    <div class="logo-list">
      <div class="logo-wrapper"><img [src]="wfImage('integraciones_02.png')" loading="lazy" width="194" alt="" class="logo is-wordpress"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('google-cloud-logo.svg')" loading="lazy" width="170" alt="" class="logo is-google"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('mongodb_slateblue.svg')" loading="lazy" width="170" alt="" class="logo is-mongo"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('twillio-1.png')" loading="lazy" width="125" alt="" class="logo is-twillio"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('whatsapp-partner.png')" loading="lazy" width="165" alt="" class="logo is-whatsapp"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('prestashop-mono-1.png')" loading="lazy" width="168" alt="" class="logo is-prestashop"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('shopify_monotone_black.svg')" loading="lazy" width="169" alt="" class="logo is-shopify"/></div>
      <div class="logo-wrapper"><img [src]="wfImage('integraciones_04.png')" loading="lazy" width="167" alt="" class="logo is-tiendanube"/></div>
    </div>
  </div>
</section>

<section class="section-service">
  <div class="padding-global">
    <div class="container-large">
      <div class="padding-section-large">
        <div class="service-component">
          <div class="margin-bottom margin-xxlarge">
            <div class="text-align-center">
              <div class="max-width-large">
                <h3 i18n="@@wf.services.sectionTitle">Unified Intelligence for Global <span class="text-no-wrap">E-commerce</span></h3>
              </div>
            </div>
          </div>
          <div class="w-layout-grid service-list">
            <div class="service-item slide-in-0-6s">
              <div class="margin-bottom margin-medium"><div class="service-image-wrapper"><div class="service-image-block"><img [src]="wfImage('icortex-ai-predictive-1a.png')" loading="lazy" alt="" width="100" class="service-image"/></div></div></div>
              <div class="margin-bottom margin-xsmall"><h3 class="heading-style-h5">Predictive Cortex™</h3></div>
              <p class="shadowp" i18n="@@wf.services.pcBody">Identify visitor purchase intent and potential friction points before they abandon the site. iCortex processes behavioral data to trigger the most effective message for every specific user.</p>
            </div>
            <div class="service-item slide-in-0-8s">
              <div class="margin-bottom margin-medium"><div class="service-image-wrapper"><div class="service-image-block"><img [src]="wfImage('lifestyle-engine-3b.png')" loading="lazy" alt="" width="100" class="service-image"/></div></div></div>
              <div class="margin-bottom margin-xsmall"><h3 class="heading-style-h5">Lifestyle Engine™</h3></div>
              <p class="shadowp" i18n="@@wf.services.leBody">Automatically transform standard product catalog photos into hyper-realistic lifestyle assets. Deliver contextual visual content that resonates with your customer&apos;s current environment and aspirations.</p>
            </div>
            <div class="service-item slide-in-1s">
              <div class="margin-bottom margin-medium"><div class="service-image-wrapper"><div class="service-image-block"><img [src]="wfImage('omnichannel-orchestra-1b.png')" loading="lazy" alt="" width="100" class="service-image is-omnichannel"/></div></div></div>
              <div class="margin-bottom margin-xsmall"><h3 class="heading-style-h5" i18n="@@wf.services.orchTitle">Omnichannel Orchestrator</h3></div>
              <p class="shadowp" i18n="@@wf.services.orchBody">iCortex orchestrates personalized engagement through WhatsApp, Push Notifications, and Email, selecting the ideal channel for each customer to maximize conversion and brand loyalty.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-feature">
  <div class="padding-global">
    <div class="container-large">
      <div class="padding-section-large">
        <div class="feature-component">
          <div class="margin-bottom margin-xxlarge">
            <div class="max-width-large">
              <div class="text-align-center">
                <h3 class="heading" i18n="@@wf.features.sectionTitle">Drive Measurable Impact with iCortex AI</h3>
              </div>
            </div>
          </div>
          <div class="feature-list w-dyn-items">
            <a class="feature-item halodarksalte" [href]="localizedPath('/technology/predictive-cortex')" style="text-decoration: none;">
              <div class="margin-bottom margin-small"><div class="feature-icon-wrapper"><div class="feature-icon-block"><img loading="lazy" alt="" [src]="wfImage('conversion-optimization.png')" class="icon-1x1-small"/></div></div></div>
              <div class="feature-content">
                <div class="margin-bottom margin-xxsmall"><h3 class="heading-style-h6" i18n="@@wf.features.f1Title">Conversion Optimization</h3></div>
                <p i18n="@@wf.features.f1Body">Maximize your ROI by identifying high-intent users and delivering the exact content needed to finalize the purchase.</p>
              </div>
            </a>
            <a class="feature-item halodarksalte" [href]="localizedPath('/solutions/ai-creative-studio')" style="text-decoration: none;">
              <div class="margin-bottom margin-small"><div class="feature-icon-wrapper"><div class="feature-icon-block"><img loading="lazy" alt="" [src]="wfImage('ai-images-1.png')" class="icon-1x1-small"/></div></div></div>
              <div class="feature-content">
                <div class="margin-bottom margin-xxsmall"><h3 class="heading-style-h6" i18n="@@wf.features.f2Title">Scalable Creative Engine</h3></div>
                <p i18n="@@wf.features.f2Body">Lower your production overhead by generating high-quality lifestyle assets autonomously with our Lifestyle Engine™.</p>
              </div>
            </a>  
            <a class="feature-item halodarksalte" [href]="localizedPath('/solutions/flows')" style="text-decoration: none;">
              <div class="margin-bottom margin-small"><div class="feature-icon-wrapper"><div class="feature-icon-block"><img loading="lazy" alt="" [src]="wfImage('paraphrase.png')" class="icon-1x1-small"/></div></div></div>
              <div class="feature-content">
                <div class="margin-bottom margin-xxsmall"><h3 class="heading-style-h6" i18n="@@wf.features.f3Title">Smart Recovery Flows</h3></div>
                <p i18n="@@wf.features.f3Body">Reduce manual intervention with intelligent, 24/7 automated workflows across WhatsApp, Push, and Email.</p>
              </div>
            </a>
            <a class="feature-item halodarksalte" [href]="localizedPath('/technology/lifestyle-engine')" style="text-decoration: none;">
              <div class="margin-bottom margin-small"><div class="feature-icon-wrapper"><div class="feature-icon-block"><img loading="lazy" alt="" [src]="wfImage('contextual-2.png')" class="icon-1x1-small"/></div></div></div>
              <div class="feature-content">
                <div class="margin-bottom margin-xxsmall"><h3 class="heading-style-h6" i18n="@@wf.features.f4Title">Contextual Personalization</h3></div>
                <p i18n="@@wf.features.f4Body">Enhance customer loyalty by providing a unique shopping experience that adapts visual assets to each user&apos;s environment.</p>
              </div>
            </a>
            <a class="feature-item halodarksalte" [href]="localizedPath('/technology/predictive-cortex')" style="text-decoration: none;">
              <div class="margin-bottom margin-small"><div class="feature-icon-wrapper"><div class="feature-icon-block"><img loading="lazy" alt="" [src]="wfImage('nodos-2.png')" class="icon-1x1-small"/></div></div></div>
              <div class="feature-content">
                <div class="margin-bottom margin-xxsmall"><h3 class="heading-style-h6" i18n="@@wf.features.f5Title">Predictive Intelligence</h3></div>
                <p i18n="@@wf.features.f5Body">Turn raw behavioral data into actionable growth strategies using the deep processing power of the Predictive Cortex.</p>
              </div>
            </a>
            <a class="feature-item halodarksalte" [href]="localizedPath('/technology/global-infrastructure')" style="text-decoration: none;">
              <div class="margin-bottom margin-small"><div class="feature-icon-wrapper"><div class="feature-icon-block"><img loading="lazy" alt="" [src]="wfImage('global-1.png')" class="icon-1x1-small"/></div></div></div>
              <div class="feature-content">
                <div class="margin-bottom margin-xxsmall"><h3 class="heading-style-h6" i18n="@@wf.features.f6Title">Global Infrastructure</h3></div>
                <p i18n="@@wf.features.f6Body">Future-proof your business with a robust architecture designed to scale seamlessly across multiple markets and platforms.</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-layout">
  <div class="padding-global">
    <div class="container-large">
      <div class="padding-section-large">
        <div class="margin-bottom margin-xxlarge">
          <div class="text-align-center">
            <div class="max-width-large align-center">
              <h3 i18n="@@wf.layout1.sectionKicker">Hyperrealistic Images sent through the Appropriate Channel</h3>
            </div>
          </div>
        </div>
        <div class="w-layout-grid layout-component">
          <div class="layout-content">
            <div class="margin-bottom margin-small">
              <h3> <span class="text-color-gradient" i18n="@@wf.layout1.hScale">Scale</span><span i18n="@@wf.layout1.hMid"> your Apparel &amp; Footwear </span><span class="text-color-gradient" i18n="@@wf.layout1.hVisual">Visual Marketing</span></h3>
            </div>
            <p class="text-size-medium" i18n="@@wf.layout1.p">Automatically place your product catalog into hyper-realistic scenes. iCortex handles the complex physics of textiles and the intricate textures of footwear, ensuring every item looks perfectly integrated into its new environment without the need for expensive photoshoots.</p>
          </div>
          <div class="layout-image-wrapper slide-in-0-6s">
            <img [src]="wfImage('lifestyle-engine-apparel-footwear-600.jpg')" loading="lazy" width="574" sizes="(max-width: 767px) 100vw, 574px" alt=""
                 [attr.srcset]="wfImage('lifestyle-engine-apparel-footwear-600-p-500.jpg') + ' 500w, ' + wfImage('lifestyle-engine-apparel-footwear-600.jpg') + ' 600w'" class="layout-image"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-layout">
  <div class="padding-global">
    <div class="container-large">
      <div class="padding-section-large">
        <div class="w-layout-grid layout-component">
          <div class="layout-content">
            <div class="margin-bottom margin-small">
              <h3><span class="text-color-gradient" i18n="@@wf.layout2.h1">Dynamic Contexts </span><span i18n="@@wf.layout2.h2">for Backpacks and accessories</span></h3>
            </div>
            <p class="text-size-medium" i18n="@@wf.layout2.p">Transport your backpacks from urban cityscapes to rugged mountain trails instantly. <br/><br/>Our engine understands the structural volume of accessories, creating a perfect lighting and shadow match for any landscape, ensuring your products resonate with your customer&apos;s specific lifestyle aspirations.</p>
          </div>
          <div class="layout-image-wrapper slide-in-0-6s">
            <img [src]="wfImage('lifestyle-engine-bags-accesories-600.jpg')" loading="lazy" width="574" sizes="(max-width: 767px) 100vw, 574px" alt=""
                 [attr.srcset]="wfImage('lifestyle-engine-bags-accesories-600-p-500.jpg') + ' 500w, ' + wfImage('lifestyle-engine-bags-accesories-600.jpg') + ' 600w'" class="layout-image"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-layout">
  <div class="padding-global">
    <div class="container-large">
      <div class="padding-section-large">
        <div class="w-layout-grid layout-component">
          <div class="layout-content">
            <div class="margin-bottom margin-small">
              <h3><span i18n="@@wf.layout3.h1">Predictive </span><span class="text-color-gradient" i18n="@@wf.layout3.h2">Intelligence</span><span i18n="@@wf.layout3.h3"> that Orchestrates Growth.</span></h3>
            </div>
            <p class="text-size-medium" i18n="@@wf.layout3.p">While the <strong>Lifestyle Engine</strong> creates the impact, the <strong>Predictive Cortex</strong> acts as the decision layer. It identifies which specific product will trigger a purchase for each individual customer. <br/><br/>By orchestrating this intelligence across WhatsApp, Email, SMS, and Push notifications—including advanced <strong>High-Intent Revenue Recovery</strong>—iCortex ensures your brand is always present with the right message at the perfect moment.</p>
          </div>
          <div class="layout-image-wrapper slide-in-0-6s">
            <img [src]="wfImage('icortex-orchestration-600.jpg')" loading="lazy" sizes="100vw"
                 [attr.srcset]="wfImage('icortex-orchestration-600-p-500.jpg') + ' 500w, ' + wfImage('icortex-orchestration-600.jpg') + ' 600w'" alt="" class="layout-image"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-testimonial">
  <div class="padding-global">
    <div class="container-large">
      <div class="padding-section-large">
        <div class="margin-bottom margin-xxlarge">
          <div class="text-align-center">
            <div class="max-width-large align-center">
              <div class="margin-bottom margin-small">
                <h2 i18n="@@wf.testimonials.title">Validated by Forward-Thinking <br/><span class="text-no-wrap">E-commerce</span> Leaders</h2>
              </div>
              <p class="text-size-medium" i18n="@@wf.testimonials.subtitle">Discover how our partners leverage the Predictive Cortex and Lifestyle Engine to drive measurable revenue growth and operational efficiency at scale.</p>
            </div>
          </div>
        </div>
        <div class="testimonial-component">
          <div class="slide-in-0-6s">
            <div class="testimonial-content">
              <div class="margin-bottom margin-small">
                <div class="text-size-medium" i18n="@@wf.testimonials.q1">&quot;iCortex has proven to be a robust solution for our operations. While the technology is powerful, the real value emerged during the implementation phase, where proper configuration within our ecosystem allowed us to see its full potential. It&apos;s not just an automated tool; it&apos;s a<strong> strategic engine</strong> that delivers results when aligned with a solid e-commerce structure.&quot;</div>
              </div>
              <div class="testimonial-client">
                <div class="testimonial-client-image-wrapper"><img [src]="wfImage('meg.jpg')" loading="lazy" width="100" alt="" class="testimonial-customer-image"/></div>
                <div class="testimonial-client-info">
                  <p class="text-weight-semibold text-color-white">Emmanuel S.</p>
                  <p i18n="@@wf.testimonials.r1role">E-commerce Operations Manager</p>
                </div>
              </div>
            </div>
          </div>
          <div class="slide-in-0-8s">
            <div class="testimonial-content">
              <div class="margin-bottom margin-small">
                <div class="text-size-medium" i18n="@@wf.testimonials.q2">&quot;iCortex has delivered exceptional results by streamlining our high-intent revenue recovery process. The platform is highly customizable, allowing us to align every touchpoint with our brand identity. In the first month alone, we successfully reclaimed <strong>65 abandoned checkouts</strong>, proving that its automated orchestration is a force multiplier for any e-commerce team focused on growth.&quot;</div>
              </div>
              <div class="testimonial-client">
                <div class="testimonial-client-image-wrapper"><img [src]="wfImage('testimonial_avatar_4.jpg')" loading="lazy" alt="Profile" class="testimonial-customer-image"/></div>
                <div class="testimonial-client-info">
                  <p class="text-weight-semibold text-color-white">Lucia A.</p>
                  <p i18n="@@wf.testimonials.r2role">Chief Revenue Officer</p>
                </div>
              </div>
            </div>
          </div>
          <div class="slide-in-1s">
            <div class="testimonial-content">
              <div class="margin-bottom margin-small">
                <div class="text-size-medium" i18n="@@wf.testimonials.q3">&quot;After just 10 days of implementation, the impact is evident. iCortex goes far beyond traditional email marketing tools by orchestrating automated, high-quality notifications across multiple channels. The content is exceptional and fully customizable, yet the system handles the <strong>heavy lifting autonomously</strong>. It&apos;s a superior alternative for brands looking for true end-to-end automation.&quot;</div>
              </div>
              <div class="testimonial-client">
                <div class="testimonial-client-image-wrapper"><img [src]="wfImage('testimonial_avatar_2.jpg')" loading="lazy" alt="Profile" class="testimonial-customer-image"/></div>
                <div class="testimonial-client-info">
                  <p class="text-weight-semibold text-color-white">Gaston P.</p>
                  <p i18n="@@wf.testimonials.r3role">E-commerce Marketing Director</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-use-case">
  <div class="padding-global">
    <div class="container-large">
      <div class="padding-section-large">
        <div class="w-layout-grid use-case-component">
          <div class="use-case-content-left">
            <div class="margin-bottom margin-small">
              <h1 class="heading-style-h2" i18n="@@wf.usecase.title">The Autonomous Growth Engine for Modern <span class="text-no-wrap">E-commerce</span>.</h1>
            </div>
            <p class="text-size-medium" i18n="@@wf.usecase.body">Empower your store with unified predictive intelligence. iCortex orchestrates revenue recovery, lifecycle engagement, and creative production to scale your brand with total autonomy and precision.</p>
            <div class="margin-top margin-medium">
              <div class="button-group">
                <a [href]="localizedPath('/solutions/ai-revenue')" class="button is-secondary w-button" i18n="@@wf.usecase.learnMore" (click)="sendGAEvent('Navigation', 'Click', 'Use case learn more')">Learn More</a>
                <a [href]="signupHref" class="button is-link is-icon w-inline-block" (click)="sendGAEvent('Conversion', 'Click', 'Use case sign up')">
                  <div i18n="@@wf.usecase.signUp">Sign Up</div>
                  <div class="icon-embed-xxsmall w-embed" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 3L11 8L6 13" stroke="CurrentColor" stroke-width="1.5"/></svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="use-case-content-right">
            <div class="w-dyn-items">
              <a [href]="localizedPath('/solutions/ai-revenue')" class="use-case-link-block w-inline-block">
                <div class="use-case-content-item">
                  <div class="margin-bottom margin-xsmall"><div class="icon-wrapper"><img alt="" loading="lazy" width="32" [src]="wfImage('revenue-orchestration-1.png')"/></div></div>
                  <div class="margin-bottom margin-xsmall"><h2 class="heading-style-h5" i18n="@@wf.usecase.card1Title">AI Revenue Orchestration</h2></div>
                  <p class="paragraph" i18n="@@wf.usecase.card1Body">iCortex manages the entire conversion funnel autonomously. From identifying early intent patterns to executing adaptive recovery sequences, the system determines the perfect channel and timing—Email, Push, SMS or Whatsapp—to reclaim every lost revenue without manual intervention.</p>
                </div>
              </a>
              <a [href]="localizedPath('/solutions/flows')" class="use-case-link-block w-inline-block">
                <div class="use-case-content-item">
                  <div class="margin-bottom margin-xsmall"><div class="icon-wrapper"><img alt="" loading="lazy" width="32" [src]="wfImage('user-flow-png.png')"/></div></div>
                  <div class="margin-bottom margin-xsmall"><h2 class="heading-style-h5" i18n="@@wf.usecase.card2Title">Strategic Engagement Flows</h2></div>
                  <p class="paragraph" i18n="@@wf.usecase.card2Body">Foster long-term loyalty and retention with automated Initial Profile Onboarding and real-time transactional alerts (email, push and SMS) that keep your brand present and trusted throughout the entire customer journey</p>
                </div>
              </a>
              <a [href]="localizedPath('/solutions/ai-creative-studio')" class="use-case-link-block w-inline-block">
                <div class="use-case-content-item">
                  <div class="margin-bottom margin-xsmall"><div class="icon-wrapper"><img alt="" loading="lazy" width="32" [src]="wfImage('creative-studio-gradient.png')"/></div></div>
                  <div class="margin-bottom margin-xsmall"><h2 class="heading-style-h5" i18n="@@wf.usecase.card3Title">High-Fidelity Creative Studio</h2></div>
                  <p class="paragraph" i18n="@@wf.usecase.card3Body">Drastically reduce production overhead by generating high-quality lifestyle assets autonomously. Replace expensive manual photoshoots with instant, AI-driven creativity that keeps your store’s visuals fresh and professional.</p>
                </div>
              </a>
              <a [href]="localizedPath('/solutions/omnichannel-news')" class="use-case-link-block w-inline-block">
                <div class="use-case-content-item">
                  <div class="margin-bottom margin-xsmall"><div class="icon-wrapper"><img alt="" loading="lazy" width="32" [src]="wfImage('channels-png-1.png')"/></div></div>
                  <div class="margin-bottom margin-xsmall"><h2 class="heading-style-h5" i18n="@@wf.usecase.card4Title">Unified Campaign Orchestration</h2></div>
                  <p class="paragraph" i18n="@@wf.usecase.card4Body">Maximize your promotional impact by launching high-conversion campaigns across Email, Push &amp; SMS simultaneously. Reach your most relevant segments through a single unified action, simplifying your workflow while amplifying your brand’s reach.</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-blog">
  <div class="padding-global">
    <div class="container-large">
      <div class="padding-section-large">
        <div class="margin-bottom margin-xxlarge">
          <div class="text-align-center">
            <div class="max-width-large align-center">
              <div class="margin-bottom margin-small">
                <h2 i18n="@@wf.blog.title">Checkout our latest post</h2>
              </div>
              <p class="text-size-medium" i18n="@@wf.blog.subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
            </div>
          </div>
        </div>
        <div class="blog-component">
          <div class="blog-list-wrapper">
            <div class="blog-collection-list w-dyn-items">
              <div class="blog-item">
                <div class="blog-link-wrapper">
                  <a href="/post/maximizing-efficiency-and-creativity" class="blog-image-link w-inline-block">
                    <div class="blog-image-wrapper"><img [src]="wfImage('thumbnai_image.jpg')" loading="lazy" alt="" sizes="100vw"
                         [attr.srcset]="wfImage('thumbnai_image-p-500.jpg') + ' 500w, ' + wfImage('thumbnai_image-p-800.jpg') + ' 800w, ' + wfImage('thumbnai_image.jpg') + ' 832w'" class="blog-image"/></div>
                  </a>
                  <a href="/post/maximizing-efficiency-and-creativity" class="blog-category-link w-inline-block"><div class="text-color-gradient" i18n="@@wf.blog.cat1">Ideas</div></a>
                  <a href="/post/maximizing-efficiency-and-creativity" class="blog-title-link w-inline-block"><h3 class="heading-style-h5" i18n="@@wf.blog.post1Title">Maximizing Efficiency and Creativity</h3></a>
                </div>
                <div class="text-size-regular" i18n="@@wf.blog.post1Excerpt">In today&apos;s fast-paced digital landscape, creating compelling and engaging content is more important than ever.</div>
              </div>
              <div class="blog-item">
                <div class="blog-link-wrapper">
                  <a href="/post/from-blank-page-to-brilliant-copy" class="blog-image-link w-inline-block">
                    <div class="blog-image-wrapper"><img [src]="wfImage('thumbnai_image-2.jpg')" loading="lazy" alt="" sizes="100vw"
                         [attr.srcset]="wfImage('thumbnai_image-2-p-500.jpg') + ' 500w, ' + wfImage('thumbnai_image-2-p-800.jpg') + ' 800w, ' + wfImage('thumbnai_image-2.jpg') + ' 832w'" class="blog-image"/></div>
                  </a>
                  <a href="/post/from-blank-page-to-brilliant-copy" class="blog-category-link w-inline-block"><div class="text-color-gradient" i18n="@@wf.blog.cat2">Productivity</div></a>
                  <a href="/post/from-blank-page-to-brilliant-copy" class="blog-title-link w-inline-block"><h3 class="heading-style-h5" i18n="@@wf.blog.post2Title">From Blank Page to Brilliant Copy</h3></a>
                </div>
                <div class="text-size-regular" i18n="@@wf.blog.post2Excerpt">In today&apos;s fast-paced digital landscape, creating compelling and engaging content is more important than ever.</div>
              </div>
              <div class="blog-item">
                <div class="blog-link-wrapper">
                  <a href="/post/how-ai-revolutionizes-content-creation" class="blog-image-link w-inline-block">
                    <div class="blog-image-wrapper"><img [src]="wfImage('thumbnai_image-4.jpg')" loading="lazy" alt="" sizes="100vw"
                         [attr.srcset]="wfImage('thumbnai_image-4-p-500.jpg') + ' 500w, ' + wfImage('thumbnai_image-4-p-800.jpg') + ' 800w, ' + wfImage('thumbnai_image-4.jpg') + ' 832w'" class="blog-image"/></div>
                  </a>
                  <a href="/post/how-ai-revolutionizes-content-creation" class="blog-category-link w-inline-block"><div class="text-color-gradient" i18n="@@wf.blog.cat3">Ideas</div></a>
                  <a href="/post/how-ai-revolutionizes-content-creation" class="blog-title-link w-inline-block"><h3 class="heading-style-h5" i18n="@@wf.blog.post3Title">How AI Revolutionizes Content Creation</h3></a>
                </div>
                <div class="text-size-regular" i18n="@@wf.blog.post3Excerpt">In today&apos;s fast-paced digital landscape, creating compelling and engaging content is more important than ever.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-top margin-xlarge">
          <div class="button-group is-center">
            <a href="/blogs" class="button is-secondary w-button" i18n="@@wf.blog.viewAll" (click)="sendGAEvent('Navigation', 'Click', 'Blog view all')">View all</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-faq">
  <div class="padding-global">
    <div class="container-small">
      <div class="padding-section-large">
        <div class="margin-bottom margin-xxlarge">
          <div class="text-align-center">
            <div class="max-width-large">
              <div class="margin-bottom margin-small">
                <h2 i18n="@@wf.faq.title">Frequently Asked Questions</h2>
              </div>
              <p class="text-size-medium" i18n="@@wf.faq.subtitle">Everything you need to know about our autonomous growth engine and how iCortex scales your e-commerce operations.</p>
            </div>
          </div>
        </div>
        <div class="faq-component">
          <div class="w-layout-grid faq-list">
            <div class="faq-accordion" [class.is-faq-open]="faqOpenIndex === 0">
              <div
                class="faq-question"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="faqOpenIndex === 0"
                (click)="toggleFaq(0)"
                (keydown)="onFaqQuestionKeydown($event, 0)">
                <div class="text-size-medium text-color-white" i18n="@@wf.faq.q1">How does the Lifestyle Engine generate content?</div>
                <img [src]="wfImage('plus.png')" loading="lazy" width="32" i18n-alt="@@wf.faq.iconExpand" alt="Icon" class="faq-icon"/>
              </div>
              <div class="faq-answer" id="wf-faq-a-0" [attr.aria-hidden]="faqOpenIndex !== 0">
                <div class="margin-bottom margin-small"><p i18n="@@wf.faq.a1">The system autonomously synchronizes with your store&apos;s titles and descriptions every 24 hours. This ensures your messaging is always fresh and aligned with your latest updates without manual intervention.</p></div>
              </div>
            </div>
            <div class="faq-accordion" [class.is-faq-open]="faqOpenIndex === 1">
              <div
                class="faq-question"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="faqOpenIndex === 1"
                (click)="toggleFaq(1)"
                (keydown)="onFaqQuestionKeydown($event, 1)">
                <div class="text-size-medium text-color-white" i18n="@@wf.faq.q2">Can I edit the automated AI messages?</div>
                <img [src]="wfImage('plus.png')" loading="lazy" width="32" i18n-alt="@@wf.faq.iconExpand" alt="Icon" class="faq-icon"/>
              </div>
              <div class="faq-answer" id="wf-faq-a-1" [attr.aria-hidden]="faqOpenIndex !== 1">
                <div class="margin-bottom margin-small"><p i18n="@@wf.faq.a2">To ensure maximum performance and dynamic rotation, messages for checkouts and product recall are generated autonomously. However, for &quot;Welcome Series&quot; and &quot;Brand Recall&quot; sequences, you maintain full creative control over the flow.</p></div>
              </div>
            </div>
            <div class="faq-accordion" [class.is-faq-open]="faqOpenIndex === 2">
              <div
                class="faq-question"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="faqOpenIndex === 2"
                (click)="toggleFaq(2)"
                (keydown)="onFaqQuestionKeydown($event, 2)">
                <div class="text-size-medium text-color-white" i18n="@@wf.faq.q3">What if I want to change an AI-generated image?</div>
                <img [src]="wfImage('plus.png')" loading="lazy" width="32" i18n-alt="@@wf.faq.iconExpand" alt="Icon" class="faq-icon"/>
              </div>
              <div class="faq-answer" id="wf-faq-a-2" [attr.aria-hidden]="faqOpenIndex !== 2">
                <div class="margin-bottom margin-small"><p i18n="@@wf.faq.a3">Our engine creates high-quality visuals once to maintain system efficiency. If you update your product photo or wish for a new perspective, you can simply use the &quot;Regenerate&quot; feature from the platform to refresh your creative assets instantly.</p></div>
              </div>
            </div>
            <div class="faq-accordion" [class.is-faq-open]="faqOpenIndex === 3">
              <div
                class="faq-question"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="faqOpenIndex === 3"
                (click)="toggleFaq(3)"
                (keydown)="onFaqQuestionKeydown($event, 3)">
                <div class="text-size-medium text-color-white" i18n="@@wf.faq.q4">How does iCortex differ from traditional email tools?</div>
                <img [src]="wfImage('plus.png')" loading="lazy" width="32" i18n-alt="@@wf.faq.iconExpand" alt="Icon" class="faq-icon"/>
              </div>
              <div class="faq-answer" id="wf-faq-a-3" [attr.aria-hidden]="faqOpenIndex !== 3">
                <div class="margin-bottom margin-small"><p i18n="@@wf.faq.a4">iCortex goes beyond static templates. It uses predictive intelligence to rotate messaging and imagery autonomously, ensuring your customers receive dynamic, non-repetitive content that drives higher engagement.</p></div>
              </div>
            </div>
            <div class="faq-accordion" [class.is-faq-open]="faqOpenIndex === 4">
              <div
                class="faq-question"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="faqOpenIndex === 4"
                (click)="toggleFaq(4)"
                (keydown)="onFaqQuestionKeydown($event, 4)">
                <div class="text-size-medium text-color-white" i18n="@@wf.faq.q5">How fast can I see results?</div>
                <img [src]="wfImage('plus.png')" loading="lazy" width="32" i18n-alt="@@wf.faq.iconExpand" alt="Icon" class="faq-icon"/>
              </div>
              <div class="faq-answer" id="wf-faq-a-4" [attr.aria-hidden]="faqOpenIndex !== 4">
                <div class="margin-bottom margin-small"><p i18n="@@wf.faq.a5">Most partners observe a significant impact within the first <strong>10 to 30 days</strong> of implementation, especially in High-Intent Revenue Recovery.</p></div>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-top margin-xxlarge">
          <div class="text-align-center">
            <div class="max-width-medium align-center">
              <div class="margin-bottom margin-xsmall"><h3 class="heading-style-h4" i18n="@@wf.faq.moreTitle">Still have questions?</h3></div>
              <p class="text-size-medium is-subtitlecenter" i18n="@@wf.faq.moreBody">We are ready to answer your questions about integration, security, and maximizing your ROI with iCortex.</p>
              <div class="margin-top margin-medium">
                <a routerLink="/contact" class="button is-secondary w-button" i18n="@@wf.faq.contactBtn" (click)="sendGAEvent('Conversion', 'Click', 'FAQ contact')">Contact</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
